/*
 * action types
 */

import { fulfilled, pending } from '../factories/ApiCall';
import type {
  RemoteSupportAction,
  RemoteSupportState,
} from '../types/RemoteSupport';

const types = {
  OPEN_TEAMVIEWER: 'REMOTE_SUPPORT/OPEN_TEAMVIEWER',
  IS_REMOTE_SUPPORT_AVAILABLE: 'REMOTE_SUPPORT/IS_REMOTE_SUPPORT_AVAILABLE',
} as const;

function payloadAs<Payload>(action: RemoteSupportAction): Payload {
  return action.payload as Payload;
}

/*
 * action creators
 */

const actions = {
  openTeamViewer: (): RemoteSupportAction => ({ type: types.OPEN_TEAMVIEWER }),
  checkIsRemoteSupportAvailable: (): RemoteSupportAction => ({
    type: types.IS_REMOTE_SUPPORT_AVAILABLE,
  }),
};

const initialState: RemoteSupportState = {
  is_remote_support_available: false,
  opening: false,
};

function reducer(
  state: RemoteSupportState = initialState,
  action: RemoteSupportAction
): RemoteSupportState {
  switch (action.type) {
    case pending(types.OPEN_TEAMVIEWER): {
      return { ...state, opening: true };
    }
    case fulfilled(types.OPEN_TEAMVIEWER): {
      return { ...state, opening: false };
    }
    case fulfilled(types.IS_REMOTE_SUPPORT_AVAILABLE): {
      return {
        ...state,
        is_remote_support_available: payloadAs<boolean>(action),
      };
    }
    default: {
      return state;
    }
  }
}

export { types as actionTypes, actions as default, reducer };
